(() => {
  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';

  const parseJson = (script, fallback) => {
    try {
      return JSON.parse(script.textContent || JSON.stringify(fallback));
    } catch {
      return fallback;
    }
  };

  const syncForm = (form) => {

    const inputs = form.querySelectorAll('.js-delivery-time-property');
    const dataEl = form.querySelector('[data-delivery-time-variants]');
    const idInput = form.querySelector('input[name="id"]');
    if (!inputs.length || !dataEl || !idInput) return;

    const messages = parseJson(dataEl, {});
    const message = messages[String(idInput.value)] || '';

    inputs.forEach((input) => {
      input.value = message;
      input.disabled = message === '';
    });
  };

  const bindForm = (form) => {
    if (form.dataset.deliveryTimeBound === 'true') return;
    if (!form.querySelector('[data-delivery-time-variants]')) return;

    form.dataset.deliveryTimeBound = 'true';
    form.addEventListener('submit', () => syncForm(form), true);

    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.addEventListener('change', () => syncForm(form));

      if (window.MutationObserver) {
        const observer = new MutationObserver(() => syncForm(form));
        observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    syncForm(form);
  };

  const init = () => {
    document.querySelectorAll(FORM_SELECTOR).forEach(bindForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
